import type { SVGProps } from "react";

// Lightweight inline-SVG nav icons (no icon-library dependency). Outline style,
// 24×24 viewBox, stroke=currentColor so they inherit the link's text color.
// Size at the call site with `className="h-5 w-5"`.
function Svg({ children, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export type NavIconComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;

export const HomeIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" />
  </Svg>
);

// Train = the practice loop → a dumbbell.
export const TrainIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M6.5 8.5v7M4 10v3M17.5 8.5v7M20 10v3M6.5 12h11" />
  </Svg>
);

// Library = your question sets → stacked books.
export const LibraryIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <rect x="4" y="4" width="4" height="16" rx="1" />
    <rect x="10" y="4" width="4" height="16" rx="1" />
    <path d="m16.6 5.4 3.3 1-3.6 14.1-3.3-1z" />
  </Svg>
);

// Create = generate → sparkles.
export const CreateIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M12 3l1.7 4.6L18.3 9.3 13.7 11 12 15.6 10.3 11 5.7 9.3 10.3 7.6z" />
    <path d="M18 14.5l.6 1.6 1.6.6-1.6.6-.6 1.6-.6-1.6-1.6-.6 1.6-.6z" />
  </Svg>
);

// Projects = the agent workspace → folder.
export const ProjectsIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M3 7a1 1 0 0 1 1-1h4.5l2 2H20a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
  </Svg>
);

// Community = clans + chat → people.
export const CommunityIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 19v-1a4 4 0 0 1 4-4h3a4 4 0 0 1 4 4v1" />
    <path d="M16 5.2a3 3 0 0 1 0 5.6" />
    <path d="M17 14.2A4 4 0 0 1 20.5 18v1" />
  </Svg>
);

// Stats = mastery + trends → bar chart.
export const StatsIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M4 20V11M10 20V4M16 20v-6M3 20h18" />
  </Svg>
);

// Settings → sliders.
export const SettingsIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M4 8h8M17 8h3M4 16h3M12 16h8" />
    <circle cx="15" cy="8" r="2" />
    <circle cx="9" cy="16" r="2" />
  </Svg>
);

// Calendar → a month grid.
export const CalendarIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 9h18M8 2v4M16 2v4" />
  </Svg>
);

// Admin = operator console → a shield with a check.
export const AdminIcon: NavIconComponent = (p) => (
  <Svg {...p}>
    <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
    <path d="m9 12 2 2 4-4" />
  </Svg>
);
